import { useState, useEffect } from "react"
import { useCouponStore } from "../../store/couponStore"
import { searchUsers } from "../../services/couponApi"
import InputField from "../Form/InputField";

export default function CouponFormModal() {

  const closeForm = useCouponStore((s) => s.closeForm)
  const selectedCoupon = useCouponStore((s) => s.selectedCoupon)
  const createCoupon = useCouponStore((s) => s.createCoupon)
  const updateCoupon = useCouponStore((s) => s.updateCoupon)

  const [formData, setFormData] = useState({
    title: "",
    code: "",
    discount_type: "PERCENT",
    discount_value: "",
    usage_limit: "",
    min_order_amount: "",
    max_discount_amount: "",
    expiration_date: "",
    is_active: true,
    user_id: null
  })


  const [errors, setErrors] = useState({})
  const [userQuery, setUserQuery] = useState("")
  const [users, setUsers] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)

  useEffect(() => {
    if (selectedCoupon) {
      setFormData({
        ...selectedCoupon,
        user_id: selectedCoupon.user?.id
      })
      setSelectedUser(selectedCoupon.user)
      setUserQuery(selectedCoupon.user?.full_name || "")
    }
  }, [selectedCoupon])

  const validate = () => {

    const newErrors = {}

    if (!formData.title) newErrors.title = "عنوان الزامی است"
    if (!formData.code) newErrors.code = "کد تخفیف الزامی است"
    if (!formData.discount_value) newErrors.discount_value = "مقدار تخفیف الزامی است"
    if (!formData.usage_limit) newErrors.usage_limit = "تعداد استفاده الزامی است"
    if (!formData.expiration_date) newErrors.expiration_date = "تاریخ انقضا الزامی است"
    if (!formData.user_id) newErrors.user = "انتخاب کاربر الزامی است"

    setErrors(newErrors)

    return Object.keys(newErrors).length === 0
  }

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    })
  }

  const handleUserSearch = async (value) => {

    setUserQuery(value)

    if (value.length < 2) {
      setUsers([])
      return
    }

    const res = await searchUsers(value)
    setUsers(res.data)
  }

  const selectUser = (user) => {

    setSelectedUser(user)

    setFormData({
      ...formData,
      user_id: user.id
    })

    setUserQuery(user.full_name || user.phone_number)
    setUsers([])
  }

  const handleSubmit = async (e) => {

    e.preventDefault()

    if (!validate()) return

    const payload = { ...formData }

    if (!payload.expiration_date) {
      delete payload.expiration_date
    }

    if (selectedCoupon) {
      await updateCoupon(selectedCoupon.id, payload)
    } else {
      await createCoupon(payload)
    }

    closeForm()
  }

  const isValid =
    !!formData.title &&
    !!formData.code &&
    !!formData.discount_value &&
    !!formData.usage_limit &&
    !!formData.expiration_date &&
    !!formData.user_id

  const handleDiscountTypeChange = (e) => {
  const value = e.target.value;

  setFormData((prev) => ({
    ...prev,
    discount_type: value,
    discount_value: "",
    max_discount_amount: value === "FIXED" ? "" : prev.max_discount_amount,
  }));
};

  return (

    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">

      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">

        {/* header */}

        <div className="flex items-center justify-between p-6 border-b">

          <h2 className="text-lg font-semibold">
            {selectedCoupon ? "ویرایش کد تخفیف" : "ایجاد کد تخفیف"}
          </h2>

          <button
            onClick={closeForm}
            className="text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>

        </div>

        {/* form */}

        <form onSubmit={handleSubmit} className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* user */}

          <div className="col-span-1 md:col-span-2">

            <label className="text-sm font-medium text-gray-700 mb-2">
              کاربر *
            </label>

            <input
                value={userQuery}
                onChange={(e) => handleUserSearch(e.target.value)}
                className={`w-full px-3 py-2 border rounded-lg text-sm font-medium text-[#1E3A5F] ${
                    errors.user ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="جستجوی کاربر"
                disabled={selectedCoupon}
            />

            {users.length > 0 && (
                <div className="border rounded-lg mt-1 max-h-40 overflow-auto">

                  {users.map((u) => (
                      <div
                          key={u.id}
                          onClick={() => selectUser(u)}
                          className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm font-medium text-[#1E3A5F]"
                      >
                        {u.full_name} - {u.phone_number}
                      </div>
                  ))}

                </div>
            )}

          </div>

          {/* title */}
          <div>
            <InputField
                label="عنوان *"
                name="title"
                value={formData.title}
                onChange={handleChange}
                className={`${
                    errors.title ? "border-red-500" : "border-gray-300"
                }`}
            />
          </div>
          {/* code */}
          <div>
            <InputField
                label="کد تخفیف *"
                name="code"
                value={formData.code}
                onChange={handleChange}
            />
          </div>

          {/* discount type */}

          <div>
            <label className="text-sm font-medium text-gray-700 mb-2">
              نوع تخفیف
            </label>

            <select
                name="discount_type"
                value={formData.discount_type}
                onChange={handleDiscountTypeChange}
                className="w-full px-3 py-2 border rounded-lg text-sm font-medium text-[#1E3A5F] mb-2"
            >
              <option value="PERCENT" className="text-sm font-medium text-[#1E3A5F] mb-2">درصد</option>
              <option value="FIXED" className="text-sm font-medium text-[#1E3A5F] mb-2">مقدار ثابت</option>
            </select>
          </div>

          {/* discount value */}
          <div>
            <InputField
                label="مقدار تخفیف *"
                type="number"
                name="discount_value"
                value={formData.discount_value}
                onChange={handleChange}
            />
          </div>

          {/* limits grid */}

            <div>
              <InputField
                  label="حداکثر تعداد استفاده"
                  type="number"
                  name="usage_limit"
                  value={formData.usage_limit}
                  onChange={handleChange}
              />
            </div>

            <div>
              <InputField
                  label=" حداقل سفارش"
                  type="number"
                  name="min_order_amount"
                  value={formData.min_order_amount}
                  onChange={handleChange}
              />
            </div>


          {/* max discount */}

          {formData.discount_type === 'PERCENT' && (<div>
            <InputField
                label="حداکثر مقدار تخفیف"
                type="number"
                name="max_discount_amount"
                value={formData.max_discount_amount}
                onChange={handleChange}
            />
          </div>)}

          {/* expiration */}

          <div>
            <InputField
                type="date"
                label="تاریخ انقضا *"
                name="expiration_date"
                value={formData.expiration_date || ""}
                onChange={handleChange}
                />

          </div>

          {/* active */}

          <div className="flex items-center">

            <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
                className="h-4 w-4"
            />

            <label className="mr-2 text-sm">
              فعال باشد
            </label>

          </div>

          {/* actions */}

          <div className="flex gap-3 pt-4">

            <button
                type="submit"
                disabled={!isValid}
                className={`px-4 py-2 rounded-lg text-white ${
                    isValid
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-gray-400 cursor-not-allowed"
                }`}
            >
              تایید
            </button>

            <button
                type="button"
                onClick={closeForm}
                className="px-4 py-2 rounded-lg bg-gray-200"
            >
              انصراف
            </button>

          </div>

        </form>

      </div>

    </div>
  )
}
